import { useAuthStore } from '@/store/auth'

export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return
  window.addEventListener('keydown', (e) => {
    if (e.metaKey && e.shiftKey && e.code === 'KeyL') {
      const auth = useAuthStore()
      auth.setUser({ uid: 'dev', email: 'dev@example.com', displayName: 'Dev User' })
      console.log('[dev-bypass] logged in')
    }
  })
})